import React, {useContext, useEffect, useState} from 'react'
import { AuthContext } from '../../../../context/AuthContext';
import toast from 'react-hot-toast';
import axios from 'axios';
import { IoMdCloseCircle } from 'react-icons/io';
import { useNavigate } from 'react-router-dom';

export default function ProfileCard() {
  const navigate = useNavigate();
  const { usuario, logout } = useContext(AuthContext);
  const [user, setUser] = useState(null);
  const [modalCambiarContraseña, setModalCambiarContraseña] = useState(false);
  const [userCambiarPassword, setUserCambiarPassword] = useState({ token_actual: '', token_acceso: '', token_refresh: '' });
  const [userParse, setUserParse] = useState(null);
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    const stored = localStorage.getItem('usuario');
    if (stored) setUser(stored);
    setUserParse(JSON.parse(stored)); 
    // setUserCambiarPassword(JSON.parse(stored));
    
  }, []);

  //console.log(JSON.parse(user));
  //console.log('este es usuario', usuario)

  const validarCoincidenciaPasswords = () => {
    return userCambiarPassword.token_acceso === userCambiarPassword.token_refresh;
  };

    const validarAnteriorPassword = () => {
    return JSON.parse(user).token_acceso === userCambiarPassword.token_actual;
  };


  const handleCambiarPassword = (e) => {
    e.preventDefault();
    if (!validarAnteriorPassword()) {
       toast.error(`La contraseña actual no coincide, con la ingresada. Verifique`, {
                duration: 4000,
                position: "top-center",
              });
      return;
    }
    if (!validarCoincidenciaPasswords()) {
       toast.error(`Valide que las dos contraseñas ingresadas, sean iguales.`, {
                duration: 4000,
                position: "top-center",
              });
      return;
    }
    
    ejecutarCambiarPassword();

    //console.log(userCambiarPassword);
    //console.log('Cambiar contraseña');
  };


  const ejecutarCambiarPassword = async () => {
    
    const userParsed = JSON.parse(user);
    const data = {...userParsed,
      token_acceso: userCambiarPassword.token_acceso,
      token_refresh: userCambiarPassword.token_refresh,
    }
    try {
      setLoading(true);
      const object = {
        peticion: 13, // Cambiar contraseña
        param: data
      }
      const response = await axios.post('https://estanciamargarita.com.ar/backendGama/php/servicios/serviciosUsuario.php',object,{
        headers: new Headers(),
      })

      if (response.data) {
        toast.success('Contraseña cambiada correctamente', {
          duration: 4000,
          position: "top-center",
        });
        // Actualizar el usuario en el localStorage
        setLoading(false);
        localStorage.removeItem('usuario');
       navigate('/'); // Redirigir al login o a donde quieras
      }
    }

    catch (error) {
      setLoading(false);
      localStorage.removeItem('usuario');
     
      console.error('Error al cambiar la contraseña:', error);
      toast.error(`Error al cambiar la contraseña: ${error.message}`, {
        duration: 4000,
        position: "top-center",
      });
        navigate('/'); // Redirigir al login o a donde quieras
    }

    finally {
      setLoading(false);
      setModalCambiarContraseña(false);
      localStorage.removeItem('usuario');
      navigate('/');
      setUserCambiarPassword({ token_actual: '', token_acceso: '', token_refresh: '' });
    }}

  return (
    <div className="md:pt-5 pt-12">

        <div className="max-w-[40vh] mx-auto bg-white dark:bg-gray-900 rounded-lg overflow-hidden shadow-lg">
            <div className="">
                <div className="text-center ">
                    <img className="h-32 w-32 rounded-full border-4 border-white dark:border-gray-800 mx-auto my-4"
                        src={usuario.foto_perfil ? usuario.foto_perfil : 'https://pedraza.com.ar/static/media/mundin-tele.c959f9f1.png' } alt=""/>
                    <div className="py-2">
                        <h3 className="font-bold text-2xl text-gray-800 dark:text-white">{usuario.nombre_completo}</h3>
                        <h6 className="text-gray-300 dark:text-white mb-1">{usuario.correo}</h6>
                        <div className="flex flex-col  gap-2 text-gray-700 dark:text-gray-300 items-center ">

                        <button 
                        onClick={logout}
                        className="inline-block w-auto text-center min-w-[100px] px-3 py-2 text-white transition-all bg-red-600 rounded-md shadow-xl sm:w-auto hover:bg-red-700 hover:text-white shadow-neutral-300 dark:shadow-neutral-700 hover:shadow-2xl hover:shadow-neutral-400 hover:-tranneutral-y-px">Cerrar sesion
                        </button>
                       

                        </div>
                         {userParse && userParse.proveedor==='mail' && <button onClick={() => setModalCambiarContraseña(true)} className='bg-zinc-800 hover:bg-zinc-950 text-white p-2 rounded-md mt-2'>
                          <span className='text-sm'>Cambiar Contraseña</span>
                        </button>}
                    </div>
                </div>
            </div>
        </div>
    {modalCambiarContraseña && (<>
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
        <div className="bg-white p-10 rounded-lg sm:max-w-sm  m-10 md:m-0 w-full md:max-w-xl text-center shadow-lg">
            <div className='flex  justify-end '>
              <button onClick={()=> setModalCambiarContraseña(false)} ><IoMdCloseCircle size={24} /></button>
              </div>
            <div className='grid gap-5 flex justify-center items-center'>
            <h2 className='text-md font-bebas p-5'>Cambiar contraseña:</h2>
            <span className='text-sm'> Para cambiar la contraseña, por favor complete el siguiente formulario: </span>
            <form className='flex flex-col gap-3' onSubmit={(e) => handleCambiarPassword(e)}>
                <input type="password" placeholder='Contraseña actual'  value={userCambiarPassword?.token_actual || ''}
                  onChange={(e) =>
                    setUserCambiarPassword((prev) => ({ ...prev, token_actual: e.target.value }))
                  }  className='border border-gray-300 p-2 rounded-md' />
                <input
                  type="password"
                  placeholder="Nueva contraseña"
                  value={userCambiarPassword?.token_acceso || ''}
                  onChange={(e) =>
                    setUserCambiarPassword((prev) => ({ ...prev, token_acceso: e.target.value }))
                  }
                  className="border border-gray-300 p-2 rounded-md"
                />
                <input
                  type="password"
                  placeholder="Confirmar nueva contraseña"
                  value={userCambiarPassword?.token_refresh || ''}
                  onChange={(e) =>
                    setUserCambiarPassword((prev) => ({ ...prev, token_refresh: e.target.value }))
                  }
                  className="border border-gray-300 p-2 rounded-md"
                />
                <button type='submit' className='bg-zinc-800 hover:bg-zinc-950 text-white p-2 rounded-md'>{!loading ? <>Cambiar contraseña</> : <>Cargando</>}</button>
            </form>
            
            
            </div>
            </div>
        </div>
    </>)}
</div>
  )
}
